'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('@material-ui/core/styles');

var _Snackbar = require('@material-ui/core/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _SnackbarContent = require('@material-ui/core/SnackbarContent');

var _SnackbarContent2 = _interopRequireDefault(_SnackbarContent);

var _IconButton = require('@material-ui/core/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Close = require('@material-ui/icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _CheckCircle = require('@material-ui/icons/CheckCircle');

var _CheckCircle2 = _interopRequireDefault(_CheckCircle);

var _Warning = require('@material-ui/icons/Warning');

var _Warning2 = _interopRequireDefault(_Warning);

var _Error = require('@material-ui/icons/Error');

var _Error2 = _interopRequireDefault(_Error);

var _Info = require('@material-ui/icons/Info');

var _Info2 = _interopRequireDefault(_Info);

var _green = require('@material-ui/core/colors/green');

var _green2 = _interopRequireDefault(_green);

var _amber = require('@material-ui/core/colors/amber');

var _amber2 = _interopRequireDefault(_amber);

var _action_notice = require('../actions/action_notice');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var stylesBar = function stylesBar(theme) {
  return {
    success: {
      backgroundColor: _green2.default[600]
    },
    error: {
      backgroundColor: theme.palette.error.dark
    },
    info: {
      backgroundColor: theme.palette.primary.dark
    },
    warning: {
      backgroundColor: _amber2.default[700]
    },
    icon: {
      fontSize: 20
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    }
  };
};

var variantIcon = {
  success: _CheckCircle2.default,
  warning: _Warning2.default,
  error: _Error2.default,
  info: _Info2.default
};

var BarContent = function BarContent(props) {
  var classes = props.classes,
      className = props.className,
      message = props.message,
      onClose = props.onClose,
      variant = props.variant,
      open = props.open,
      other = _objectWithoutProperties(props, ['classes', 'className', 'message', 'onClose', 'variant', 'open']);

  var Icon = variantIcon[variant];

  return _react2.default.createElement(
    _Snackbar2.default,
    {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      open: open,
      autoHideDuration: 6000,
      onClose: onClose
    },
    _react2.default.createElement(_SnackbarContent2.default, _extends({
      className: (0, _classnames2.default)(classes[variant], className),
      'aria-describedby': 'client-snackbar',
      message: _react2.default.createElement(
        'span',
        {
          id: 'client-snackbar',
          className: (0, _classnames2.default)(classes.message, 'txt-notice')
        },
        _react2.default.createElement(Icon, { className: (0, _classnames2.default)(classes.icon, classes.iconVariant) }),
        message
      ),
      action: [_react2.default.createElement(
        _IconButton2.default,
        {
          key: 'close',
          'aria-label': 'Close',
          color: 'inherit',
          className: classes.close,
          onClick: onClose
        },
        _react2.default.createElement(_Close2.default, { className: classes.icon })
      )]
    }, other))
  );
};

BarContent.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  className: _propTypes2.default.string.isRequired,
  message: _propTypes2.default.node.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool.isRequired,
  variant: _propTypes2.default.oneOf(['success', 'warning', 'error', 'info']).isRequired
};

var BarContentWrapper = (0, _styles.withStyles)(stylesBar)(BarContent);

// - - - - - - - - - - - - - - - - - - - - - - - - - - -
//
// Notice
//
// - - - - - - - - - - - - - - - - - - - - - - - - - - -
var stylesNotice = function stylesNotice(theme) {
  return {
    margin: {
      margin: theme.spacing.unit
    }
  };
};

var BarContentMain = function BarContentMain(variant, className, message, open, onClose) {
  return _react2.default.createElement(BarContentWrapper, {
    variant: variant,
    className: className,
    message: message,
    open: open,
    onClose: onClose
  });
};

var Notice = function Notice(_ref) {
  var classes = _ref.classes,
      noticeSt = _ref.noticeSt,
      manualClearAct = _ref.manualClearAct;
  var status = noticeSt.status,
      message = noticeSt.message;


  return _react2.default.createElement(
    'div',
    null,
    status && message ? BarContentMain(status, classes.margin, message, Boolean(status), manualClearAct) : null
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    noticeSt: state.notice
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    manualClearAct: _action_notice.manualClear
  }, dispatch);
};

Notice.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  noticeSt: _propTypes2.default.object.isRequired,
  manualClearAct: _propTypes2.default.func.isRequired
};

exports.default = (0, _redux.compose)((0, _styles.withStyles)(stylesNotice), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(Notice);